<div [ngClass]="{ 'modal-container': !atendimento }">
  <suite-rfb-collapse [title]="titulo" id="mensagemAlerta">
    <suite-rfb-alert-messages-with-datetime
      [onlyFor]="scopeId"
    ></suite-rfb-alert-messages-with-datetime>
    <div style="display: flex; align-items: stretch; gap: 10px">
      <div class="contorno2" style="flex: 1;">
        <suite-rfb-collapse
          [collapsed]="filtroColapsado"
          (collapsedChange)="colapsar($event)"
          title="DE Original"
        >
          <form>
            <div class="row">
              <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                <div class="form-group">
                  <label class="control-label">Contribuinte</label>
                  <input
                    type="text"
                    class="form-control"
                    [disabled]="true"
                    [value]="this.docArrecRetificaBase1.ni | formatCpfCnpjPipe | vazio"
                    readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                <div class="form-group">
                  <label class="control-label">PA</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="
                      this.docArrecRetificaBase1.periodoApuracao | date : 'dd/MM/yyyy'
                    "
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4'">
                <div class="form-group">
                  <label class="control-label">Data Vencimento</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="
                      this.docArrecRetificaBase1.dataVencimento | date : 'dd/MM/yyyy'
                    "
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Referência</label>
                  <input
                  class="form-control"
                  type="text"
                  autocomplete="off"
                  [value]="this.docArrecRetificaBase1.referencia | vazio"
                  [disabled]="true"
                  readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Processo</label>
                  <input
                  class="form-control"
                  type="text"
                  autocomplete="off"
                  [value]="this.docArrecRetificaBase1.processo | vazio"
                  [disabled]="true"
                  readonly
                  />
                </div>
              </div>  
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">ID CEF</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="this.docArrecRetificaBase1.idCEF | vazio"
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
              <div class="col-md-6 mt-12">
                <div class="form-group">
                  <label class="control-label">VRBA</label>
                  <input
                    class="form-control numerico"
                    type="text"
                    autocomplete="off"
                    [value]="this.docArrecRetificaBase1.vrba | vazio"
                    [disabled]="true"
                    suiteRfbNumbersOnly
                    readonly
                  />
                </div>
              </div>
              <div class="col-md-6 mt-12">
                <div class="form-group">
                  <label class="control-label">Percentual</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="this.docArrecRetificaBase1.vrbaPercentual | vazio"
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Data Arrecadação</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="
                      this.docArrecRetificaBase1.dataArrecadacao | date : 'dd/MM/yyyy'
                    "
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Banco</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="this.docArrecRetificaBase1.codigoBanco | vazio"
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Agência</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    [value]="this.docArrecRetificaBase1.codigoAgencia | vazio"
                    [disabled]="true"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="contorno">
              <div class="container-fluid">
                @if (this.docArrecRetificaBase1.codigoReceita01 !== undefined) {
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Receita</label>
                      <via-codigo-receita
                        [codigo]="
                          this.docArrecRetificaBase1.codigoReceita01
                        "
                        id ="codigoReceita01"
                      >
                      </via-codigo-receita>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Valor</label>
                      <input
                        class="form-control numerico"
                        type="text"
                        align="right"
                        autocomplete="off"
                        [value]="
                        this.docArrecRetificaBase1.valorReceita01
                            | number : '1.2-2'
                            | vazio
                        "
                        [disabled]="true"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                } @if (this.docArrecRetificaBase1.codigoReceita02 !== undefined) {
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Receita</label>
                      <via-codigo-receita
                        [codigo]="
                        this.docArrecRetificaBase1.codigoReceita02
                        "
                        id ="codigoReceita02"
                      >
                      </via-codigo-receita>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Valor</label>
                      <input
                        class="form-control numerico"
                        type="text"
                        autocomplete="off"
                        [value]="
                            this.docArrecRetificaBase1.valorReceita02
                            | number : '1.2-2'
                            | vazio
                        "
                        [disabled]="true"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                } @if (this.docArrecRetificaBase1.codigoReceita03 !== undefined) {
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Receita</label>
                      <via-codigo-receita
                        [codigo]="
                        this.docArrecRetificaBase1.codigoReceita03
                        "
                        id ="codigoReceita03"
                      >
                      </via-codigo-receita>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Valor</label>
                      <input
                        class="form-control numerico"
                        type="text"
                        autocomplete="off"
                        [value]="
                            this.docArrecRetificaBase1.valorReceita03
                            | number : '1.2-2'
                            | vazio
                        "
                        [disabled]="true"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </form>
        </suite-rfb-collapse>
      </div>

      <div class="contorno2" style="flex: 1;">
        <suite-rfb-collapse
          [collapsed]="filtroColapsado"
          (collapsedChange)="colapsar($event)"
          title="PARA Alterado"
        >

          <form [formGroup]="formGroup" (ngSubmit)="retificar()">
            <div class="row">
              @if (retificacaoCompleta) {
                @if (niEhCNPJ) {
                  <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                    <div class="form-group">
                      <label class="control-label">Contribuinte</label>
                      <input class="form-control"
                        type="text"
                        formControlName="ni"
                        autocomplete="off"
                        suiteRfbInputMask="99.999.999/9999-99"
                        suiteRfbValidCnpj>
                    </div>
                  </div>
                }
                @else if (niEhCPF) {
                  <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                    <div class="form-group">
                      <label class="control-label">Contribuinte</label>
                      <input class="form-control"
                        type="text"
                        formControlName="ni"
                        autocomplete="off"
                        suiteRfbInputMask="999.999.999-99"
                        suiteRfbValidCpf>
                    </div>
                  </div>
                }
              } 
              @else if (retificacaoSimplificada) {
                @if (niEhCNPJ) {
                  <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                    <div class="form-group">
                      <label class="control-label">Contribuinte</label>
                      <div style="display: flex;">
                        <input
                          class="form-control cnpj1"
                          type="text"
                          [style]="retificacaoRealizada ? 'width: 100px;' : ''"
                          autocomplete="off"
                          [value]="this.docArrecRetificaBase1.ni | formatCpfCnpjPipe"
                          disabled
                          suiteRfbInputMask="99.999.999/"
                        />
                        <input
                          class="form-control cnpj2"
                          [style]="retificacaoRealizada ? 'padding-left: 0px;' : ''"
                          type="text"
                          formControlName="ni"
                          autocomplete="off"
                          maxlength="7"
                          value=""
                          suiteRfbInputMask="9999-99"
                        />
                      </div>
                    </div>
                  </div>
                }
                @else if (niEhCPF) {
                  <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                    <div class="form-group">
                      <label class="control-label">Contribuinte</label>
                      <input class="form-control"
                        type="text"
                        formControlName="ni"
                        autocomplete="off"
                        suiteRfbInputMask="999.999.999-99"
                        disabled
                        suiteRfbValidCpf>
                    </div>
                  </div>
                }
              }

              <div [class]="atendimento ? 'col-xs-6' : 'col-xs-4'">
                <div class="form-group">
                  <label class="control-label">PA</label>
                    <suite-rfb-date-picker
                      adaptivePosition="true"
                      formControlName="periodoApuracao"
                    >
                    </suite-rfb-date-picker>
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4'">
                <div class="form-group">
                  <label class="control-label">Data Vencimento</label>
                  <suite-rfb-date-picker
                    adaptivePosition="true"
                    formControlName="dataVencimento">
                  </suite-rfb-date-picker>
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Referência</label>
                      <input
                        class="form-control"
                        type="text"
                        autocomplete="off"
                        formControlName="referencia"
                        suiteRfbNumbersOnly
                      />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Processo</label>
                      <input
                        class="form-control"
                        type="text"
                        autocomplete="off"
                        formControlName="processo"
                        suiteRfbNumbersOnly
                      />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">ID CEF</label>
                      <input
                        class="form-control"
                        type="text"
                        autocomplete="off"
                        formControlName="idCEF"
                        suiteRfbNumbersOnly
                      />
                </div>
              </div>
              <div class="col-md-6 mt-12">
                <div class="form-group">
                  <label class="control-label">VRBA</label>
                      <input
                        class="form-control"
                        type="text"
                        autocomplete="off"
                        formControlName="vrba"
                        (keyup)="
                          this.formatarValor($event.target.value, 2)
                        "
                        suiteRfbNumbersOnly
                      />
                </div>
              </div>
              <div class="col-md-6 mt-12">
                <div class="form-group">
                  <label class="control-label">Percentual</label>
                      <input
                        class="form-control"
                        type="text"
                        autocomplete="off"
                        formControlName="vrbaPercentual"
                        (keyup)="
                          this.formatarValor($event.target.value, 2)
                        "
                        suiteRfbNumbersOnly
                      />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Data Arrecadação</label>
                  <suite-rfb-date-picker
                    adaptivePosition="true"
                    formControlName="dataArrecadacao"
                  >
                  </suite-rfb-date-picker>
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label">Banco</label>
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    formControlName="codigoBanco"
                    suiteRfbNumbersOnly
                  />
                </div>
              </div>
              <div [class]="atendimento ? 'col-xs-6 mt-12' : 'col-xs-4 mt-12'">
                <div class="form-group">
                  <label class="control-label campos-menores numerico"
                    >Agência</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    autocomplete="off"
                    formControlName="codigoAgencia"
                    suiteRfbNumbersOnly
                  />
                </div>
              </div>
            </div>

            <div class="contorno">
              <div class="container-fluid">
               <div class="row">
                  <div class="col-md-6">                    
                    <div class="form-group">  
                      
                      @if (this.docArrecRetificaBase1.codigoReceita01 !== undefined) {
                        <label for="receitas" class="control-label">Receita</label>
                        <ng-select 
                          class="form-control"
                          [style.width]="atendimento ? '174px' : '283px'"
                          name="receita" 
                          [items]="this.listaReceitas" 
                          bindLabel="descricaoCompleta" 
                          [title]="this.formGroup.controls['codigoReceita01'].value.descricao"
                          [formControlName]="this.codigoReceita + '1'"
                          placeholder="Selecione"
                          [searchable]="true"
                          [virtualScroll]="true"
                        >
                        <ng-template let-item="item">
                          {{ item?.codigo }} - {{ item?.descricao }}
                        </ng-template>
                      </ng-select>
                        

                      } @else {
                          <label class="control-label">Receita</label>
                          <div>-</div>                          
                      }  
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Valor</label>
                        <div class="form-group">
                          <suite-rfb-currency
                            inline
                            [formControlName]="this.valorReceita + '1'"
                            (keyup)="somaReceita()"
                          ></suite-rfb-currency>
                        </div>
                    </div>
                  </div>
                </div>  
                <div class="row">
                    <div class="col-md-6">                    
                      <div class="form-group">  
                        @if (this.docArrecRetificaBase1.codigoReceita02 !== undefined) {
                         <label for="receitas" class="control-label">Receita</label>
                          <ng-select 
                            class="form-control"
                            [style.width]="atendimento ? '174px' : '283px'"
                            name="receita" 
                            [items]="this.listaReceitas" 
                            bindLabel="descricaoCompleta" 
                            [title]="this.formGroup.controls['codigoReceita02'].value.descricao"
                            [formControlName]="this.codigoReceita + '2'"
                            placeholder="Selecione"
                            [searchable]="true"
                            [virtualScroll]="true"
                            
                          >
                          <ng-template let-item="item">
                            {{ item?.codigo }} - {{ item?.descricao }}
                          </ng-template>
                        </ng-select>
                        } @else {
                            <label class="control-label">Receita</label>
                            <div>-</div>                          
                        }  
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="control-label">Valor</label>
                          <div class="form-group">
                            <suite-rfb-currency
                              inline
                              [formControlName]="this.valorReceita + '2'"
                              (keyup)="somaReceita()"
                            ></suite-rfb-currency>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="row">
                   <div class="col-md-6">      
                      @if (this.docArrecRetificaBase1.codigoReceita03 !== undefined) {
                        <label for="receitas" class="control-label">Receita</label>
                          <ng-select 
                            class="form-control"
                            [style.width]="atendimento ? '174px' : '283px'"
                            name="receita" 
                            [items]="this.listaReceitas" 
                            bindLabel="descricaoCompleta" 
                            [title]="this.formGroup.controls['codigoReceita03'].value.descricao"
                            [formControlName]="this.codigoReceita + '3'"
                            placeholder="Selecione"
                            [searchable]="true"
                            [virtualScroll]="true"
                          >
                          <ng-template let-item="item">
                            {{ item?.codigo }} - {{ item?.descricao }}
                          </ng-template>
                        </ng-select>
                      } @else {
                        <div class="form-group">
                          <label class="control-label">Receita</label>
                          <div>-</div>                          
                        </div>
                      }   
                    </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">Valor</label>
                        <div class="form-group">
                          <suite-rfb-currency
                            inline
                            [formControlName]="this.valorReceita + '3'"
                            (keyup)="somaReceita()"
                          ></suite-rfb-currency>
                        </div>
                    </div>
                  </div>
                </div>
               @if (this.docArrecRetificaBase1.codigoReceita01 !== undefined) {
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">TOTAL</label>

                      <div class="form-group">
                        <input
                          class="form-control numerico"
                          type="text"
                          autocomplete="off"
                          [value]="this.totalReceitaPara | number : '1.2-2'"
                          [disabled]="true"
                          suiteRfbNumbersOnly
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                </div>
                }
                <div class="row">
                  <div class="col-md-6">
                    <button
                      style="margin-bottom: 5px;"
                      type="button"
                      class="btn btn-default"
                      (click)="carregaReceita()"
                      [disabled]="formGroup.controls['codigoReceita01'].pristine || retificacaoRealizada"
                    >
                      Carregar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </suite-rfb-collapse>
      </div>
    </div>

    <form [formGroup]="formGroup" (ngSubmit)="retificar()">
      <div style="padding-top: 10px">
        <div class="contorno" style="border-width: 3px; padding: 10px;">
          <div class="row">
            <div class="form-group dados-retificacao">
              <div class="col-md-4">
                Origem Erro Banco:
              </div>
              <div class="col-md-2">
                <label class="radio-inline">
                  <input
                    type="radio"
                    formControlName="origemErro"
                    [value]="this.TipoOrigemErro.BANCO"
                    #origemErroBanco
                  />
                  <span>Sim</span>
                </label>
              </div>
              <div class="col-md-2">
                <label class="radio-inline">
                  <input
                    type="radio"
                    formControlName="origemErro"
                    [value]="this.TipoOrigemErro.NAO_BANCO"
                    #origemErroNaoBanco
                  />
                  <span>Não</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group dados-retificacao">
              <div class="col-md-4">Processo de Retificação</div>
              <div class="col-md-4">
                <input
                  class="input-text-pesquisa"
                  type="text"
                  autocomplete="off"
                  formControlName="processoAlteracao"
                  suiteRfbNumbersOnly
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6" style="margin-top: 25px">
              <div class="form-group">
                <div class="text-left">
                  <button
                    type="reset"
                    class="btn btn-default"
                    [disabled]="!formGroup.dirty || retificacaoRealizada"
                  >
                    Limpar
                  </button>
                  <button type="submit" [disabled]="retificacaoRealizada" class="btn btn-primary">
                    Retificar
                  </button>
                  <button type="button" [disabled]="!retificacaoRealizada" (click)="onEmitirComprovante();" class="btn btn-primary">
                    Emitir comprovante
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </suite-rfb-collapse>

  <suite-rfb-confirmation
    #confirmaEmissaoComprovante
    [customBody]="perguntaEmissao"
    (accept)="onEmitirComprovante()"
  >
  </suite-rfb-confirmation>

  <ng-template #perguntaEmissao>
    <div style="width: 480px">
      <span>{{ "Deseja emitir o comprovante de retificação?" }}</span>
    </div>
  </ng-template>

  <ng-template #templateVazio>
    {{ "" | vazio }}
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    {{ formatarItem(item) }}
  </ng-template>
</div>
